"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
class Logger {
    static log(level, message) {
        // TODO: how should errors be shown https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems?id=849134
        if (level > Logger.LOGLEVEL) {
            return;
        }
        let levelStr = '';
        switch (level) {
            case 3:
                levelStr = 'ERROR';
                break;
            case 4:
                levelStr = 'WARN';
                break;
            case 5:
                levelStr = 'INFO';
                break;
            default:
                levelStr = 'DEBUG';
        }
        const str = this.handleUnknown(message);
        console.log(`${levelStr} : ${str}`);
    }
    static error(message) {
        this.log(Logger.LEVEL.error, message);
    }
    static warn(message) {
        this.log(Logger.LEVEL.warn, message);
    }
    static info(message) {
        this.log(Logger.LEVEL.info, message);
    }
    static debug(message) {
        this.log(Logger.LEVEL.debug, message);
    }
    static handleUnknown(error) {
        if (error instanceof Error) {
            return error.message;
        }
        if (typeof error === 'string') {
            return error;
        }
        return JSON.stringify({ error });
    }
}
exports.Logger = Logger;
Logger.LEVEL = { error: 3, warn: 4, info: 5, debug: 6 };
Logger.LOGLEVEL = Logger.LEVEL.warn;
//# sourceMappingURL=Logger.js.map